module.exports = __webpack_public_path__ + "82123fd501f2924ecb274803110c1dc2.svg";